import React, { useState, useEffect } from "react";
import axios from "axios";
import NavigationBar from "../layout/NavigationBar";
import Footer from "../layout/footer";
import "datatables.net-dt/css/jquery.dataTables.css";
import $ from "jquery";
import "datatables.net";

function UserMonitoring() {
  const [userAnswersData, setUserAnswersData] = useState([]);
  const [levelsData, setLevelsData] = useState([]);
  const [dataTable, setDataTable] = useState(null);
  const [autoRefresh, setAutoRefresh] = useState(false);
  const [refreshInterval, setRefreshInterval] = useState(null);
  const [selectedLevel, setSelectedLevel] = useState("");
  const [lastUpdated, setLastUpdated] = useState(new Date());
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showRewardModal, setShowRewardModal] = useState(false);
  const [selectedUserForReward, setSelectedUserForReward] = useState(null);
  const [rewardAmount, setRewardAmount] = useState('');
  const [transactionId, setTransactionId] = useState('');
  const [rewardNotes, setRewardNotes] = useState('');
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetchLevels();
    fetchUserAnswers();

    if (autoRefresh) {
      const interval = setInterval(() => {
        fetchUserAnswers();
      }, 30000); // Refresh every 30 seconds
      setRefreshInterval(interval);

      return () => clearInterval(interval);
    }
  }, [autoRefresh, selectedLevel]);

  useEffect(() => {
    if (userAnswersData.length >= 0) {
      if (dataTable) {
        dataTable.destroy();
      }

      // Ensure table is empty before reinitializing
      $('#userMonitoring tbody').empty();

      const table = $("#userMonitoring").DataTable({
        data: userAnswersData,
        columns: [
          { data: null, render: (data, type, row, meta) => meta.row + 1 }, // S.No
          {
            data: "user",
            render: (data) => `
            <div class="d-flex align-items-center">
              ${data.profileImage ?
                `<img src="${data.profileImage}" alt="Profile" class="rounded-circle mr-2" width="30" height="30">` :
                '<div class="bg-secondary rounded-circle mr-2 d-flex align-items-center justify-content-center" style="width:30px;height:30px;"><i class="fa fa-user text-white"></i></div>'
              }
              <div>
                <div class="font-weight-bold">${data.nickName || 'Unknown'}</div>
                <small class="text-muted">${data.mobile || ''}</small>
              </div>
            </div>
          `
          },
          {
            data: "level",
            render: (data) => data ? `<span class="badge badge-primary">${data.levelName}</span>` : '-'
          },
          {
            data: "treasure",
            render: (data) => data ? data.treasurePlace : '-'
          },
          {
            data: "question",
            render: (data) => `
            <div title="${data.questionText}">
              ${data.questionText.length > 40 ? data.questionText.substring(0, 40) + '...' : data.questionText}
              <br><small class="text-muted">Difficulty: ${data.difficultyLevel}</small>
            </div>
          `
          },
          {
            data: "selectedAnswer",
            render: (data) => data.length > 30 ? data.substring(0, 30) + '...' : data
          },
          {
            data: "isCorrect",
            render: (data) => data ?
              '<span class="badge badge-success"><i class="fa fa-check"></i> Correct</span>' :
              '<span class="badge badge-danger"><i class="fa fa-times"></i> Wrong</span>'
          },
          {
            data: "timeTaken",
            render: (data) => data ? `${data}s` : '-'
          },
          {
            data: "answeredAt",
            render: (data) => {
              const date = new Date(data);
              return `
              <div>
                <div>${date.toLocaleDateString()}</div>
                <small class="text-muted">${date.toLocaleTimeString()}</small>
              </div>
            `;
            }
          },
          {
            data: "rewardInfo", // New reward status column
            render: (data, type, row) => {
              if (!data) {
                return row.isCorrect && row.level ?
                  '<span class="badge badge-secondary">Eligible</span>' :
                  '<span class="badge badge-light">N/A</span>';
              }
              switch (data.reward_status) {
                case 'sent':
                  return `
                  <span class="badge badge-success">Sent ₹${data.reward_amount}</span>
                  <br><small class="text-muted">${data.transaction_id || ''}</small>
                `;
                case 'pending':
                  return `<span class="badge badge-warning">Pending ₹${data.reward_amount}</span>`;
                case 'failed':
                  return `<span class="badge badge-danger">Failed ₹${data.reward_amount}</span>`;
                default:
                  return '<span class="badge badge-secondary">Unknown</span>';
              }
            }
          },
          {
            data: null,
            orderable: false,
            render: (data, type, row, meta) => {

              return `
              <button class="btn btn-sm btn-primary" onclick="viewAnswerDetails(${meta.row})" title="View Details">
                <i class="fa fa-eye"></i>
              </button>
            `;
            }
          }
        ],
        pageLength: 25,
        lengthMenu: [10, 25, 50, 100],
        order: [[8, 'desc']], // Sort by answered date
        responsive: true,
        destroy: true, // Add this to ensure clean reinitialization
        drawCallback: function () {
          // Ensure global functions are available after redraw
          window.viewAnswerDetails = viewAnswerDetails;
          window.openRewardModal = openRewardModal;
        }
      });
      setDataTable(table);
    }
  }, [userAnswersData]);

  useEffect(() => {
    // Cleanup function to properly destroy DataTable
    return () => {
      if (dataTable) {
        try {
          dataTable.destroy();
          setDataTable(null);
        } catch (error) {
          console.warn('Error destroying DataTable:', error);
        }
      }
    };
  }, []);

  const fetchLevels = async () => {
    try {
      const response = await axios({
        method: "POST",
        url: process.env.REACT_APP_APIURL,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          environment: "live",
          apikey: process.env.REACT_APP_APIKEY,
          secret: process.env.REACT_APP_SECRET,
          method: "getAllLevels",
          module: "user",
        }),
      });

      const data = response.data;
      if (data.statusCode === 200) {
        setLevelsData(data.result);
      }
    } catch (error) {
      console.error("Error fetching levels:", error);
    }
  };

  const fetchUserAnswers = async () => {
    try {
      // Only show loading for initial fetch, not for auto-refresh
      if (userAnswersData.length === 0) {
        setLoading(true);
      }

      const response = await axios({
        method: "POST",
        url: process.env.REACT_APP_APIURL,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          environment: "live",
          apikey: process.env.REACT_APP_APIKEY,
          secret: process.env.REACT_APP_SECRET,
          method: "getUserAnswerMonitoring",
          module: "question",
          index: 1,
          limit: 1000,
          levelId: selectedLevel || undefined,
        }),
      });


      const data = response.data;
      if (data.statusCode === 200 && data.result && data.result.answers) {
        setUserAnswersData(data.result.answers);
        setLastUpdated(new Date());
      } else {
        setUserAnswersData([]);
      }
    } catch (error) {
      console.error("Error fetching user answers:", error);
      setUserAnswersData([]);
    } finally {
      setLoading(false);
    }
  };

  const viewAnswerDetails = (rowIndex) => {
    const answerData = userAnswersData[rowIndex];
    setSelectedAnswer(answerData);
    setShowDetailModal(true);
  };

  // Make viewAnswerDetails globally accessible (add this after useEffect hooks)
  useEffect(() => {
    window.viewAnswerDetails = viewAnswerDetails;
    return () => {
      delete window.viewAnswerDetails;
    };
  }, [userAnswersData]);

  // Add this function to close the modal
  const closeDetailModal = () => {
    setShowDetailModal(false);
    setSelectedAnswer(null);
  };
  const handleRefreshToggle = () => {
    setAutoRefresh(!autoRefresh);
    if (refreshInterval) {
      clearInterval(refreshInterval);
      setRefreshInterval(null);
    }
  };

  const handleManualRefresh = () => {
    fetchUserAnswers();
  };

  const handleLevelFilter = (e) => {
    setSelectedLevel(e.target.value);
  };
  // Add these functions before the return statement
  const openRewardModal = (rowIndex) => {
    const answerData = userAnswersData[rowIndex];
    if (!answerData.isCorrect || !answerData.level) {
      alert('Reward can only be sent for correct answers with valid levels');
      return;
    }
    setSelectedUserForReward(answerData);
    setRewardAmount('');
    setTransactionId('');
    setRewardNotes('');
    setShowRewardModal(true);
  };

  const sendReward = async () => {
    if (!rewardAmount || !transactionId) {
      alert('Please fill all required fields');
      return;
    }

    try {
      const response = await axios({
        method: "POST",
        url: process.env.REACT_APP_APIURL,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          environment: "live",
          apikey: process.env.REACT_APP_APIKEY,
          secret: process.env.REACT_APP_SECRET,
          method: "updateRewardStatus",
          module: "question",
          userId: selectedUserForReward.user.userId,
          levelId: selectedUserForReward.level.levelId,
          reward_status: "sent",
          reward_amount: parseFloat(rewardAmount),
          transaction_id: transactionId,
          notes: rewardNotes,
          // admin_id: "YOUR_ADMIN_USER_ID" // Replace with actual admin ID
        }),
      });

      if (response.data.statusCode === 200) {
        alert('Reward sent successfully!');
        setShowRewardModal(false);
        fetchUserAnswers(); // Refresh data
      } else {
        alert('Error sending reward: ' + response.data.message);
      }
    } catch (error) {
      console.error("Error sending reward:", error);
      alert('Error sending reward');
    }
  };

  // Make sure global functions are properly set
  useEffect(() => {
    window.viewAnswerDetails = viewAnswerDetails;
    window.openRewardModal = openRewardModal;
    return () => {
      delete window.viewAnswerDetails;
      delete window.openRewardModal;
    };
  }, [userAnswersData]);

  return (
    <div className="wrapper" id="root">
      <header>
        <NavigationBar />
      </header>

      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0 txt_lft">
                  User Answer Monitoring
                  <i className="fa-solid fa-chart-line ml-2" />
                </h1>
              </div>
              <div className="col-sm-6 text-right">
                <div className="d-inline-flex align-items-center">
                  <small className="text-muted mr-3">
                    Last updated: {lastUpdated.toLocaleTimeString()}
                  </small>
                  <button
                    className="btn btn-sm btn-outline-primary mr-2"
                    onClick={handleManualRefresh}
                    title="Manual Refresh"
                  >
                    <i className="fa fa-sync"></i>
                  </button>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="autoRefresh"
                      checked={autoRefresh}
                      onChange={handleRefreshToggle}
                    />
                    <label className="form-check-label" htmlFor="autoRefresh">
                      Auto Refresh
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="content">
          <div className="container-fluid">
            <div className="row mb-3">
              <div className="col-md-3">
                <select
                  className="form-control"
                  value={selectedLevel}
                  onChange={handleLevelFilter}
                >
                  <option value="">All Levels</option>
                  {levelsData.map((level) => (
                    <option key={level._id} value={level._id}>
                      {level.level_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-9">
                <div className="alert alert-info mb-0">
                  <i className="fa fa-info-circle mr-2"></i>
                  Monitoring user responses to treasure hunt questions. Data refreshes every 30 seconds when auto-refresh is enabled.
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                {loading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                    <p className="mt-3 text-muted">Loading user answers...</p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table
                      id="userMonitoring"
                      className="table table-striped table-bordered txt_lft"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>User</th>
                          <th>Level</th>
                          <th>Treasure</th>
                          <th>Question</th>
                          <th>Answer</th>
                          <th>Result</th>
                          <th>Time</th>
                          <th>Answered At</th>
                          <th>Reward Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                )}
              </div>

            </div>
          </div>
        </div>
      </div>

      {showDetailModal && selectedAnswer && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-xlg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Answer Details</h5>
                <button type="button" className="close" onClick={closeDetailModal}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                {/* User Details */}
                <div className="card mb-3">
                  <div className="card-header">
                    <h6 className="mb-0"><i className="fa fa-user mr-2"></i>User Details</h6>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-3 text-center">
                        {selectedAnswer.user.profileImage ? (
                          <img src={selectedAnswer.user.profileImage} alt="Profile" className="rounded-circle" width="80" height="80" />
                        ) : (
                          <div className="bg-secondary rounded-circle mx-auto d-flex align-items-center justify-content-center" style={{ width: '80px', height: '80px' }}>
                            <i className="fa fa-user fa-2x text-white"></i>
                          </div>
                        )}
                      </div>
                      <div className="col-md-9">
                        <table className="table table-sm table-borderless">
                          <tbody>
                            <tr>
                              <td><strong>Name:</strong></td>
                              <td>{selectedAnswer.user.nickName || 'Unknown'}</td>
                            </tr>
                            <tr>
                              <td><strong>Mobile:</strong></td>
                              <td>{selectedAnswer.user.mobile || 'N/A'}</td>
                            </tr>
                            <tr>
                              <td><strong>User ID:</strong></td>
                              <td><small className="text-muted">{selectedAnswer.user.userId}</small></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Level Details */}
                {selectedAnswer.level && (
                  <div className="card mb-3">
                    <div className="card-header">
                      <h6 className="mb-0"><i className="fa fa-layer-group mr-2"></i>Level Details</h6>
                    </div>
                    <div className="card-body">
                      <table className="table table-sm table-borderless">
                        <tbody>
                          <tr>
                            <td><strong>Level Name:</strong></td>
                            <td><span className="badge badge-primary">{selectedAnswer.level.levelName}</span></td>
                          </tr>
                          <tr>
                            <td><strong>Level ID:</strong></td>
                            <td><small className="text-muted">{selectedAnswer.level.levelId}</small></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {/* Treasure Details */}
                {selectedAnswer.treasure && (
                  <div className="card mb-3">
                    <div className="card-header">
                      <h6 className="mb-0"><i className="fa fa-gem mr-2"></i>Treasure Details</h6>
                    </div>
                    <div className="card-body">
                      <table className="table table-sm table-borderless">
                        <tbody>
                          <tr>
                            <td><strong>Treasure Place:</strong></td>
                            <td>{selectedAnswer.treasure.treasurePlace}</td>
                          </tr>
                          <tr>
                            <td><strong>Status:</strong></td>
                            <td>
                              {selectedAnswer.treasure.huntStatus === 'hunted' && (
                                <span className="badge badge-success"><i className="fa fa-check mr-1"></i>Hunted</span>
                              )}
                              {selectedAnswer.treasure.huntStatus === 'opened' && (
                                <span className="badge badge-info"><i className="fa fa-eye mr-1"></i>Opened Only</span>
                              )}
                              {selectedAnswer.treasure.huntStatus === 'not_hunted' && (
                                <span className="badge badge-secondary"><i className="fa fa-times mr-1"></i>Not Hunted</span>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td><strong>Treasure ID:</strong></td>
                            <td><small className="text-muted">{selectedAnswer.treasure.treasureId}</small></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {/* Answer Details */}
                <div className="card">
                  <div className="card-header">
                    <h6 className="mb-0"><i className="fa fa-question-circle mr-2"></i>Answer Details</h6>
                  </div>
                  <div className="card-body">
                    <div className="mb-3">
                      <strong>Question:</strong>
                      <p className="mt-2 p-2 bg-light rounded">{selectedAnswer.question.questionText}</p>
                    </div>

                    <table className="table table-sm table-borderless">
                      <tbody>
                        <tr>
                          <td><strong>Selected Answer:</strong></td>
                          <td>{selectedAnswer.selectedAnswer}</td>
                        </tr>
                        <tr>
                          <td><strong>Result:</strong></td>
                          <td>
                            {selectedAnswer.isCorrect ? (
                              <span className="badge badge-success"><i className="fa fa-check mr-1"></i>Correct</span>
                            ) : (
                              <span className="badge badge-danger"><i className="fa fa-times mr-1"></i>Wrong</span>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td><strong>Difficulty Level:</strong></td>
                          <td>
                            <span className={`badge ${selectedAnswer.question.difficultyLevel === 'easy' ? 'badge-success' :
                              selectedAnswer.question.difficultyLevel === 'medium' ? 'badge-warning' : 'badge-danger'
                              }`}>
                              {selectedAnswer.question.difficultyLevel.toUpperCase()}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><strong>Time Taken:</strong></td>
                          <td>{selectedAnswer.timeTaken || 0} seconds</td>
                        </tr>
                        <tr>
                          <td><strong>Answered At:</strong></td>
                          <td>{new Date(selectedAnswer.answeredAt).toLocaleString()}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={closeDetailModal}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}

export default UserMonitoring;